export default __webpack_public_path__ + "static/media/actor_image_bg.8179009a.png";